import React, { FC } from 'react';

interface Props {
  title: string | React.ReactNode;
  mainText: string | React.ReactNode;
  buttons: React.ReactNode;
  image: React.ReactNode;
}

export const DafStatusInformerLayout: FC<Props> = ({
  title,
  mainText,
  buttons,
  image,
}) => (
  <div className='card min-desktop-m:pr-0 max-desktop-s:flex-1 flex h-[320px] items-center gap-5 p-5'>
    <div className='flex flex-1 flex-col justify-between gap-2 self-stretch'>
      <div>
        <div className='font-heading text-heading-l'>{title}</div>
        <div className='text-m-regular mt-4'>{mainText}</div>
      </div>
      <div className='flex gap-2'>{buttons}</div>
    </div>
    <div className='max-desktop-m:hidden flex-none'>{image}</div>
  </div>
);
